/* eslint-disable */
/* Shim for deprecated uvoAutocomplete. Only modifies html layout for compatibility */
$.fn.uvoAutocomplete = $.fn.uvoAutocomplete || function() {
  return this.each(function(_, el) {
    if (el.uvoAutocompleteShimInitialized) return;
    el.uvoAutocompleteShimInitialized = true;
    var $el = $(el);
    var $wrapper = $('<div class="uvo_pref-uvoAutocomplete-wrapper" />');
    var $icon = $('<span class="ui-icon ui-icon-triangle-1-s" style="position: absolute; cursor: pointer; right: 10px; top: 0px;" />');
    $el.wrap($wrapper);
    $el.after($icon);
    $el.addClass('uvo_pref-uvoAutocomplete-input');
    $el.css({ appearance: 'none', '::-ms-expand': 'none' });
    $icon.css({ pointerEvents: 'none' });
  })
};



/* ==========================================================================
   3. Custom JS for writing-expert.com
   ========================================================================== */


$(function() {
	//toplink click
	$('.totop-link').click(function() {
		$('body,html').animate({
			scrollTop: 0
		}, 800);
		return false;
	});
	//toggle topmenu
	$('.toggle-menu').click(function() {
		$(this).toggleClass('active');
		if ($(this).next().css('display') == 'none') {
			$(this).next().show();
		} else {
			$(this).next().hide();
		}
		return false;
	});
	if ($('.topmenu-line').length > 0) {
		var tmenu = $('.topmenu-line'),
			tmenuTop = $('.topmenu-line').offset().top;
	}

	$(window).scroll(function() {
		//fixed menu
		var scrlTopPos = $(window).scrollTop(),
			windowWidth = parseInt($(window).width()) + 17;
		if (windowWidth >= 968) {
			if (scrlTopPos <= tmenuTop) {
				$(tmenu).removeClass('fixed');
			} else if (scrlTopPos > tmenuTop) {
				$(tmenu).addClass('fixed');
			}
		}
		//show to-top link
		if ($(window).scrollTop() >= 200) {
			$('.totop-link').fadeIn();
		} else {
			$('.totop-link').fadeOut();
		}
	});

	//mobile top menu
	$(function() {
		$('body').click(function(e) {
			$("#top_menu ul").removeClass('active');
			$(".toggle-responsive-menu").removeClass('active');
		});
		$("#top_menu ul").click(function(e) {
			e.stopPropagation();
		});
		$('.toggle-responsive-menu').click(function(e) {
			$(this).toggleClass('active');
			$('#top_menu ul').toggleClass('active').animate({
				duration: 700
			});
			e.stopPropagation();
			return false;
		});

		//dropdown menu
		$('.dropdown').click(function(e) {
			$('.dropdown-menu').toggleClass('open');
		});

	});

	//for inquiry page
	$('.show-hide').find('.hidden').hide();
	$('#inq-done-more').click(function() {
		if (!$(this).hasClass('less')) {
			$(this).parents('.show-hide').find('.hidden').slideDown(500);
			$(this).text('Read less').addClass('less');
		} else {
			$(this).parents('.show-hide').find('.hidden').slideUp(500);
			$(this).text('Read more').removeClass('less');
		}
	});

	$('#plagiarizm-checker #rightplagpanel').clone().appendTo(
		'#plagiarizm-checker').attr('id', 'rightplagpanel_2');

});

document.addEventListener("DOMContentLoaded", function() {
	$(window).on("load", function() {
		$('.bxslider').bxSlider({
			mode: 'fade',
			auto: true
		});
	});
});




/* ==========================================================================
   4. Custom JS for writing-expert.com
   ========================================================================== */

/* =============================
*  NEW CALC INIT
================================ */

//CALC MINI
$.getScript('/assets/js/calc.js', function () {
  if ($('[data-calc-mini]').length > 0) {
    new Calc({
      ID: '20',
      calculatorType: 'DefaultCalculator',
      format: 'html',
      environment: getEnvironment,
      options: {
        deafault: {
          deadlinesDefault: [135625],
          academicLevelDefault: 1,
          paperTypesDefault: 1,
          pagesDefault: 1
        }
      }

    });
  }
});

/* =============================
*  end NEW CALC INIT
================================ */

(function(window, document) {
  function init() {
    window.NotifyWidget({
      siteId: '20',
      container: '.NotifyWidget-banner'
    });
  }

  if (typeof window.NotifyWidget !== 'undefined') {
    init();
  } else {
    const script = document.createElement('script');
    script.src = '/assets/js/notifyWidget.min.js';
    script.async = true;
    script.onload = function () {
      init();
    };
    document.getElementsByTagName('head')[0].appendChild(script);
  }
})(window, document);


(function toggleListInit() {
  if (!document.querySelector('[data-page="frequently_asked_questions"]') && !document.querySelector('[data-page="money_back_guarantee"]')) return false;

  function toggle_list() {
    $('.toggle-list .toggle-content').addClass('hide');
    $(document).on('click', '.toggle-list .toggle-link', function(){
      if($(this).next().hasClass('hide')){ $(this).next().slideDown(500); }else{ $(this).next().slideUp(500); }
      $(this).parent().toggleClass('active');
      $(this).next().toggleClass('hide');
      return false;
    });
  }

  window.addEventListener('contentRendered', toggle_list);
})();
